import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getFechasSenaladasUrlByFechaId,
  insertFechaSenaladaUrl,
  deleteFechaSenaladaUrl,
  updateFechaSenaladaUrl,
  getFechasSenaladasUrlSortImagesByFechaId,
  updateFechaSenaladaUrlSortImages,
} from 'services/catalogo'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_FECHAS_SENALADAS_URL_BY_FECHA_ID(action) {
  try {
    const fechasSenaladasUrlData = yield call(getFechasSenaladasUrlByFechaId, action.payload)
    if (fechasSenaladasUrlData.ok) {
      yield put({
        type: actions.FECHAS_SENALADAS_URL_LOAD_SUCCEEDED,
        payload: fechasSenaladasUrlData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar fechas señaladas Url')
      put({
        type: actions.FECHAS_SENALADAS_URL_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.FECHAS_SENALADAS_URL_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_FECHAS_SENALADAS_URL_SORT_IMAGES_BY_FECHA_ID(action) {
  try {
    const fechasSenaladasUrlData = yield call(
      getFechasSenaladasUrlSortImagesByFechaId,
      action.payload,
    )
    if (fechasSenaladasUrlData.ok) {
      yield put({
        type: actions.FECHA_SENALADA_URL_GET_SORT_IMAGES_SUCCEEDED,
        payload: fechasSenaladasUrlData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar fechas señaladas Url Imagenes ordenar')
      put({
        type: actions.FECHA_SENALADA_URL_GET_SORT_IMAGES_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.FECHA_SENALADA_URL_GET_SORT_IMAGES_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_FECHA_SENALADA_URL(action) {
  try {
    const fechaSenaladaUrlObj = yield call(insertFechaSenaladaUrl, action.payload)
    if (fechaSenaladaUrlObj.ok) {
      putMessage(messageType.SUCCESS, 'Fecha Señalada Url creada correctamente')
      yield put({
        type: actions.FECHAS_SENALADAS_URL_INSERT_SUCCEEDED,
        payload: fechaSenaladaUrlObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear fecha Señalada Url')
      yield put({
        type: actions.FECHAS_SENALADAS_URL_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear fecha Señalada Url')
    yield all([
      put({
        type: actions.FECHAS_SENALADAS_URL_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_FECHA_SENALADA_URL(action) {
  try {
    const fechaSenaladaUrlObj = yield call(updateFechaSenaladaUrl, action.payload)
    if (fechaSenaladaUrlObj.ok) {
      putMessage(messageType.SUCCESS, 'Fecha Señalada Url modificada correctamente')
      yield put({
        type: actions.FECHAS_SENALADAS_URL_UPDATE_SUCCEEDED,
        payload: fechaSenaladaUrlObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar fecha Señalada Url')
      yield put({
        type: actions.FECHAS_SENALADAS_URL_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar fecha Señalada Url')
    yield all([
      put({
        type: actions.FECHAS_SENALADAS_URL_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_FECHA_SENALADA_URL_SORT_IMAGES(action) {
  try {
    const fechaSenaladaUrlObj = yield call(updateFechaSenaladaUrlSortImages, action.payload)
    if (fechaSenaladaUrlObj.ok) {
      putMessage(messageType.SUCCESS, 'Orden de Fecha Señalada Url modificado correctamente')
      yield put({
        type: actions.FECHAS_SENALADAS_URL_SORT_IMAGES_UPDATE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar el Orden de fecha Señalada Url')
      yield put({
        type: actions.FECHAS_SENALADAS_URL_SORT_IMAGES_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar el Orden de fecha Señalada Url')
    yield all([
      put({
        type: actions.FECHAS_SENALADAS_URL_SORT_IMAGES_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_FECHA_SENALADA_URL(action) {
  try {
    const fechaSenaladaUrlResult = yield call(deleteFechaSenaladaUrl, action.payload)
    if (fechaSenaladaUrlResult.ok) {
      putMessage(messageType.SUCCESS, 'Fecha Señalada url eliminada correctamente')
      yield put({
        type: actions.FECHA_SENALADA_URL_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Fecha Señalada url')
      yield put({
        type: actions.FECHA_SENALADA_URL_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Fecha Señalada url')
    yield all([
      put({
        type: actions.FECHA_SENALADA_URL_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FECHAS_SENALADAS_URL_LOAD_REQUESTED, GET_FECHAS_SENALADAS_URL_BY_FECHA_ID),
    takeEvery(
      actions.FECHA_SENALADA_URL_GET_SORT_IMAGES_REQUESTED,
      GET_FECHAS_SENALADAS_URL_SORT_IMAGES_BY_FECHA_ID,
    ),
    takeEvery(actions.FECHAS_SENALADAS_URL_INSERT_REQUESTED, INSERT_FECHA_SENALADA_URL),
    takeEvery(actions.FECHAS_SENALADAS_URL_UPDATE_REQUESTED, UPDATE_FECHA_SENALADA_URL),
    takeEvery(
      actions.FECHAS_SENALADAS_URL_SORT_IMAGES_UPDATE_REQUESTED,
      UPDATE_FECHA_SENALADA_URL_SORT_IMAGES,
    ),
    takeEvery(actions.FECHA_SENALADA_URL_DELETE_REQUESTED, DELETE_FECHA_SENALADA_URL),
  ])
}
